var _excluded = ["items", "button"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment } from "react";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../hooks/useBreakpoint";
var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 6h-4V2c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2v4H2a2 2 0 1 0 0 4h4v4a2 2 0 1 0 4 0v-4h4a2 2 0 1 0 0-4Z"
  }));
};
Plus.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import ButtonAtm from "../../atoms/ButtonAtm";
import IconAtm from "../../atoms/IconAtm";
import AlignContentOrg from "../../organisms/AlignContentOrg";
import ProductBundleMolItem from "./ProductBundleMolItem";
var Container = styled.div.withConfig({
  componentId: "sc-1ljyzeu-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["margin-bottom:", ";padding:", ";border-radius:", ";background:", ";&:last-child{margin-bottom:0;}", "{display:flex;align-items:center;justify-content:space-between;}> *:last-child{flex-shrink:0;}"], space(2), space(2), getBorderRadius(theme, "large"), getColor(theme, "background"), breakpoint("huge"));
});
var Items = styled.div.withConfig({
  componentId: "sc-1ljyzeu-1"
})(["margin-bottom:", ";", "{display:flex;align-items:center;}", "{margin-right:", ";margin-bottom:0;}> *{margin-bottom:", ";", "{margin-right:", ";margin-bottom:0;&:last-child{margin-right:0;}}}"], space(2), breakpoint("large"), breakpoint("huge"), space(4), space(2), breakpoint("large"), space(3));
function ProductBundleMol(_ref2) {
  var items = _ref2.items,
    button = _ref2.button,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var isMediumUp = useBreakpoint("medium");
  var isMediumOnly = useBreakpoint("medium", "huge");
  var isLargeUp = useBreakpoint("large");
  var plusIconJsx = isLargeUp ? /*#__PURE__*/React.createElement(IconAtm, {
    icon: Plus,
    sizeSpace: 2
  }) : /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "center"
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: Plus,
    sizeSpace: 1.5
  }));
  var buttonJsx = /*#__PURE__*/React.createElement(ButtonAtm, {
    color: "primary",
    to: button.to,
    href: button.href,
    title: button.title,
    onClick: button.onClick,
    rel: button.rel,
    isWider: isMediumOnly,
    isExpanded: !isMediumUp
  }, button.text);
  var buttonWrapperJsx = isMediumUp ? /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "center"
  }, buttonJsx) : /*#__PURE__*/React.createElement(React.Fragment, null, buttonJsx);
  return /*#__PURE__*/React.createElement(Container, restProps, /*#__PURE__*/React.createElement(Items, null, items.map(function (item, id) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: item.title
    }, /*#__PURE__*/React.createElement(ProductBundleMolItem, item), id + 1 < items.length && plusIconJsx);
  })), buttonWrapperJsx);
}
export default ProductBundleMol;